import React from "react";
import AttendChart from "./barChart/attentChart";
import AttendReportTable from "./allDataTable/attendReportTable";

const AttendReport = ({ dates }) => {
    // const [tableData, setTableData] = useState(false);
    const tableData = false;
    // const handleOpen = () => {
    //     setTableData(!tableData);
    // };
    return (
        <>
            <div className="gridItemParent resGrid33">
                <div className="flexCol card  elivation whiteBg pdngMD">
                    <div className="flexRow alignCntr">
                        <div className="flexMinWidthRow">
                            <span className="cardHdngTxt ellipsisTxt">Attend Report</span>
                        </div>
                        {/* <Link to="/billing-table">
                            <div className="flexAutoRow" onClick={handleOpen}>
                                <Button variant="text" className="link">
                                    View All
                                </Button>
                            </div>
                        </Link> */}
                    </div>
                    <div className="flexRow justifyCntr alignCntr">
                        <AttendChart dates={dates} />
                    </div>
                </div>
            </div>
            {tableData && <AttendReportTable />}
        </>
    );
};
export default AttendReport;
